import { WButton } from "@/components/button/WButton.tsx";
import { NoticeBlock } from "@/components/NoticeBlock.tsx";
import { accessImpersonationListQuery } from "@/modules/access/impersonation/accessImpersonationApi.ts";
import { useStandardSuspenseQuery } from "@/modules/api/useStandardMutation.ts";
import { profileLink } from "@/modules/user/profileLink.ts";
import { Trans } from "@lingui/react/macro";

export function InvitationNotice() {
    const { data } = useStandardSuspenseQuery(accessImpersonationListQuery);

    const pending = [...data.values()].filter((item) => !item.is_accepted);
    if (!pending.length) {
        return null;
    }

    return (
        <NoticeBlock
            icon="jp-warning-icon"
            button={
                <WButton color="primary" action={profileLink}>
                    <Trans>View more</Trans>
                </WButton>
            }
        >
            <b className="uppercase">
                <Trans>Access has been shared with you</Trans>
            </b>
            <br />
            {pending.map((item) => (
                <span className="block" key={item.uuid}>
                    <Trans>Access invitation from {item.access_owner} is pending</Trans>
                </span>
            ))}
        </NoticeBlock>
    );
}
